import * as React from 'react';
import { observer } from 'src/utils/mobx-react';
import { action, makeObservable } from 'mobx';
import { TabIdType } from './MainViewTypes';
import { TabLabel } from './DebugPanel.style';
import { useCommon } from 'src/domains/common/Common';
import { DebugPanelState } from 'src/domains/layouts/webview/components/debugPanel/DebugPanelState';

class MainViewTabState {
    public constructor(
        public readonly debugPanel: DebugPanelState,
        public readonly tabId: TabIdType
    ) {
        makeObservable(this);
    }

    @action public changeTab = (): void => {
        this.debugPanel.changeTab(this.tabId);
    };
}

interface MainViewTabPropsType {
    tabId: TabIdType;
    name: string;
}

export const MainViewTab = observer('MainViewTab', (props: MainViewTabPropsType) => {
    const { tabId, name } = props;
    const common = useCommon();
    const debugPanel = DebugPanelState.get(common);
    const [state] = React.useState(() => new MainViewTabState(debugPanel, tabId));
    return (
        <TabLabel
            active={debugPanel.activeTab === tabId}
            onClick={state.changeTab}
        >
            {name}
        </TabLabel>
    );
});
